import React from "react";
import {Route, Switch} from "react-router-dom";
import {URLs} from "../util/Constants";
import SeleccionarProceso from "./SeleccionarProceso/SeleccionarProceso";
import SeleccionarProcesoAyuda from "./SeleccionarProcesoAyuda/SeleccionarProcesoAyuda";
import BreadcrumbItem from "../components/UI/Breadcrumb/BreadcrumbItem";
import Documentos from "./Documentos/Documentos";

export const ScreensRoot = () => (
  <>

    <BreadcrumbItem to={URLs.HOME} text={"Inicio"}/>
    <BreadcrumbItem to={URLs.SELECCIONAR_PROCESO} text={"Entrega documentos"}/>

    <Switch>
      <Route exact path={URLs.HOME} component={SeleccionarProceso}/>
      <Route exact path={URLs.SELECCIONAR_PROCESO} component={SeleccionarProceso}/>
      <Route path={URLs.SELECCIONAR_PROCESO_AYUDA} component={SeleccionarProcesoAyuda}/>
      <Route path={URLs.CARGA_DOCUMENTAL} component={Documentos}/>
      <Route path={URLs.ESTADO_DOCUMENTOS} component={Documentos}/>
    </Switch>

  </>
);
